import React, { useContext, useEffect, useState } from 'react';
import BlogItems from '~/components/blog/blogItems';
import Layout from '~/components/layout/_layout';
import styled from 'styled-components';
import { LangContext } from '~/providers/LangProvider';
import { Trans } from '@lingui/react';

const ArticleList = ({ posts, country }) => {
    const ctxLang = useContext(LangContext);
    const [postsToShow, setPostsToShow] = useState(null);

    const getBlogPosts = lang => {
        let filteredPosts = JSON.parse(posts).filter(function(post) {
            return post.language === lang && post.country === ctxLang.state.country;
        });

        setPostsToShow(JSON.stringify(filteredPosts));
    };

    useEffect(() => {
        getBlogPosts(ctxLang.state.lang);
    }, [ctxLang.state.lang]);

    console.log(JSON.parse(postsToShow))
    return (
        <Layout country={country} business>
            <BlogWrapper>
                {postsToShow === null || postsToShow === '[]' ? (
                    <NoArticles>
                        <Trans id="blog.noArticles" />
                    </NoArticles>
                ) : (
                    <BlogItems
                        posts={JSON.parse(postsToShow)}
                        country={country}
                    />
                )}
            </BlogWrapper>
        </Layout>
    );
};

const BlogWrapper = styled.div`
    width: 100%;
    max-width: 978px;
    margin: auto;
`;

const NoArticles = styled.h1`
    text-align: center;
    padding: 50px;
`;
export default ArticleList;
